import { render } from "./Tray.vue?vue&type=template&id=1b1ab59a&scoped=true"
import script from "./Tray.vue?vue&type=script&lang=js"
export * from "./Tray.vue?vue&type=script&lang=js"

import "../styles/Tray.scss?vue&type=style&index=0&id=1b1ab59a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1ab59a"]])

export default __exports__